import { IS_FETCHING_BILLING_DETAILS } from 'constants/actions';

export const isFetchingBillingDetails = isFetching => {
  return {
    type: IS_FETCHING_BILLING_DETAILS,
    isFetching,
  };
};
